export enum Notification {
    Recontact = 'recontact',
}
